/* eslint-disable no-lonely-if */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React from "react";
import { Checkbox } from "antd";
import ModuleHeader from "./ModuleHeader";
import { chargerPermissions } from "./data";
import PermissionTitle from "./PermissionTitle";
import { PERMISSIONS } from "../../Login/constants";
import { chargerAddEditDelete } from "./permissionFunctions";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";

const CONDITIONS = {
  VIEW_AND_EDIT: [PERMISSIONS.CHARGER_VIEW, PERMISSIONS.CHARGER_NO_ACCESS],

  REMOVE_ALL: [
    PERMISSIONS.CHARGER_ADD,
    PERMISSIONS.CHARGER_EDIT,
    PERMISSIONS.CHARGER_DELETE,
    PERMISSIONS.CHARGER_VIEW,
    PERMISSIONS.CHARGER_VIEW_AND_EDIT,
    PERMISSIONS.CHARGER_NO_ACCESS,
  ],
};

const ChargerPermissions = ({ permissions, setPermissions }) => {
  // check if the permissions needs to be disabled
  const disabled = CONDITIONS.VIEW_AND_EDIT.some((d) =>
    permissions.includes(d),
  );

  const handleModulePermission = (permissionId) => {
    let local = [];

    if (permissionId === PERMISSIONS.CHARGER_VIEW_AND_EDIT) {
      local = permissions.filter(
        (item) => !CONDITIONS.VIEW_AND_EDIT.includes(item),
      );
    }

    // removing all the battery permissions
    if (permissionId === PERMISSIONS.CHARGER_VIEW) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    // removing all the battery permissions
    if (permissionId === PERMISSIONS.CHARGER_NO_ACCESS) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    setPermissions([...local, permissionId]);
  };

  const handleIndividualPermission = (permissionId) => {
    let local = [];
    if (permissions.includes(permissionId)) {
      local = permissions.filter((item) => item !== permissionId);
      setPermissions(local);
    } else {
      // handling multiple insertions for battery add, edit, delete
      if (permissionId === PERMISSIONS.CHARGER_ADD) {
        chargerAddEditDelete({ setPermissions });
      } else {
        setPermissions((prev) => [...prev, permissionId]);
      }
    }
  };

  return (
    <div>
      <ModuleHeader
        module="Chargers"
        icon={<ChargerIcon size={16} className="text-primary" />}
      />
      {/* main module permission */}
      <div className="w-full h-[60px]">
        <div
          className="flex items-center w-full h-full border-b"
          style={{
            background: "#FAF2D8",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="w-[40%] border-r py-3 px-6"
            style={{
              borderColor: "#FAD152",
            }}
          >
            <PermissionTitle
              title={chargerPermissions[0].title}
              description={chargerPermissions[0].description}
            />
          </div>

          <div className="w-[60%] h-full flex items-center">
            {chargerPermissions[0].options.map((option) => {
              // rendering empty div for layout consistency
              if (!option) {
                return (
                  <div
                    className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                    style={{
                      borderColor: "#FAD152",
                    }}
                  />
                );
              }

              const selected = permissions.includes(option.permissionId);

              return (
                <div
                  key={option.text}
                  className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                  style={{
                    borderColor: "#FAD152",
                  }}
                >
                  <Checkbox
                    checked={selected}
                    onClick={() => handleModulePermission(option.permissionId)}
                  />
                  <p
                    className={`font-poppins text-xs ${
                      selected ? "font-medium" : "font-normal"
                    }`}
                  >
                    {option.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* individual functionality permission */}
      <div className="w-full">
        {chargerPermissions.slice(1).map((item) => {
          return (
            <div
              key={item.id}
              className="flex items-center w-full h-[60px] border-b"
              style={{
                borderColor: "#DFDFDF",
              }}
            >
              <div
                className="w-[40%] h-full border-r py-3 px-6"
                style={{
                  borderColor: "#DFDFDF",
                }}
              >
                <PermissionTitle
                  title={item.title}
                  description={item.description}
                />
              </div>

              <div className="w-[60%] h-full flex items-center">
                {item.options.map((option, idx) => {
                  // rendering empty div for layout consistency
                  if (!option) {
                    return (
                      <div
                        key={idx}
                        className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                        style={{
                          borderColor: "#DFDFDF",
                        }}
                      />
                    );
                  }

                  const selected = permissions.includes(option.permissionId);

                  // if the permission is view only, remove pointer events and add an opacity
                  return (
                    <div
                      key={option.text}
                      className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                      style={{
                        borderColor: "#DFDFDF",
                        opacity: disabled && 0.5,
                        pointerEvents: disabled && "none",
                      }}
                    >
                      {/* if the permissions should be disabled then it should not
                          show any tick mark else show the selected tick mark */}
                      <Checkbox
                        checked={disabled ? false : selected}
                        onClick={() =>
                          handleIndividualPermission(option.permissionId)
                        }
                      />
                      <p
                        className={`font-poppins text-xs
                            ${selected ? "font-medium" : "font-normal"}
                            `}
                      >
                        {option.text}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChargerPermissions;
